/** Enum for expandable elements states. */
export enum ExpandState {
  Collapsed = 'collapsed',
  Expanded = 'expanded'
}
